export default "__VITE_ASSET__B$r42kcq__"